export default "/wp-content/themes/onnit/script/cart/dist/alphabrain-a4828050.jpg";